import { render, staticRenderFns } from "./Crop.vue?vue&type=template&id=36c5301c&scoped=true"
import script from "./Crop.vue?vue&type=script&lang=js"
export * from "./Crop.vue?vue&type=script&lang=js"
import style0 from "./Crop.vue?vue&type=style&index=0&id=36c5301c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c5301c",
  null
  
)

export default component.exports